import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const Bundamba = () => (
  <CostcoLocationTemplate
    warehouseName="Ipswich"
    suburb="Bundamba"
    state="Queensland"
    stateShort="QLD"
    address="Warwick Rd, Bundamba QLD 4304"
    path="/costco/ipswich"
    nearbySuburbs={[
      'Bundamba',
      'Ipswich',
      'Booval',
      'Silkstone',
      'Brassall',
      'North Ipswich',
      'Raceview',
      'Flinders View',
      'Redbank Plains',
      'Springfield',
    ]}
    description="Manage Your Loans is the exclusive Costco member loan partner serving the Ipswich warehouse in Bundamba and the wider Western Corridor. From affordable family homes in Ipswich to new builds in Springfield, our brokers know the local market and can help you earn Costco Shop Card rewards on your settled loans."
    localContext={[
      'Ipswich remains one of Southeast Queensland\'s most affordable property markets, attracting first home buyers and young families priced out of Brisbane\'s inner suburbs.',
      'The Springfield master-planned community and surrounding growth areas are driving significant new housing development and population growth along the Western Corridor.',
      'Major infrastructure projects including the Ipswich Motorway upgrades and Springfield Central rail link continue to improve connectivity and support property value growth.',
    ]}
    faqs={[
      {
        q: 'How do I earn a Costco Shop Card through the Ipswich warehouse?',
        a: 'Apply for a loan through Manage Your Loans as a Costco Executive Member. When your loan settles, you\'ll receive a Costco Shop Card reward that can be used at the Ipswich Bundamba warehouse or any Australian Costco location.',
      },
      {
        q: 'What loan options are available for buyers in the Ipswich area?',
        a: 'We offer home loans, refinancing, investment loans, car loans, personal loans, and asset finance. With Ipswich\'s affordable median prices, many buyers can enter the market with competitive deposit requirements.',
      },
      {
        q: 'Is Springfield included in the Ipswich Costco service area?',
        a: 'Absolutely. Our service covers all suburbs in the Western Corridor including Springfield, Springfield Lakes, Redbank Plains, and the broader Ipswich region. You can apply online from anywhere.',
      },
      {
        q: 'Can I refinance my existing Ipswich home loan and still earn a Shop Card?',
        a: 'Yes. Refinancing is one of our most popular services. If you\'re an Executive Member and your refinanced loan settles through us, you\'ll be eligible for the Costco Shop Card reward.',
      },
    ]}
    suburbData={{
      suburb: 'Bundamba',
      medianHouse: '$520,000',
      medianUnit: '$350,000',
      daysOnMarket: '30 days',
      rentalYield: '4.8%',
      population: '5,500',
      distanceToCostco: '1 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Ipswich', medianHouse: '$480,000', medianUnit: '$320,000', daysOnMarket: '28 days' },
      { suburb: 'Booval', medianHouse: '$500,000', medianUnit: '$330,000', daysOnMarket: '30 days' },
      { suburb: 'Silkstone', medianHouse: '$520,000', medianUnit: '$340,000', daysOnMarket: '29 days' },
      { suburb: 'Brassall', medianHouse: '$550,000', medianUnit: '$360,000', daysOnMarket: '27 days' },
      { suburb: 'North Ipswich', medianHouse: '$470,000', medianUnit: '$310,000', daysOnMarket: '31 days' },
      { suburb: 'Raceview', medianHouse: '$540,000', medianUnit: '$350,000', daysOnMarket: '28 days' },
      { suburb: 'Flinders View', medianHouse: '$560,000', medianUnit: '$370,000', daysOnMarket: '26 days' },
      { suburb: 'Redbank Plains', medianHouse: '$580,000', medianUnit: '$380,000', daysOnMarket: '24 days' },
      { suburb: 'Springfield', medianHouse: '$650,000', medianUnit: '$420,000', daysOnMarket: '22 days' },
    ]}
  />
);

export default Bundamba;
